import { render, staticRenderFns } from "./Cclass.vue?vue&type=template&id=0a7b032c&scoped=true&"
import script from "./Cclass.vue?vue&type=script&lang=js&"
export * from "./Cclass.vue?vue&type=script&lang=js&"
import style0 from "./Cclass.vue?vue&type=style&index=0&id=0a7b032c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b032c",
  null
  
)

export default component.exports